// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phone-input__input {
    padding-left: 4rem !important;
}

.phone-input__container .is-invalid {
    border-bottom: 1px solid red !important;
}

.phone-input__container .is-invalid:focus{
    box-shadow: 0 1px 0 0 red !important;
}

.phone-input__container {
    width: 100% !important;
    margin-right: 1rem;
}

.phone-input__container .selected-flag {
    padding: 0 !important;
}

.phone-input__container .flag-dropdown::before  {
    content: none !important;
}

.phone-input__container input.phone-input__input {
    width: 38.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/telephone-input/TelephoneInput.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".phone-input__input {\r\n    padding-left: 4rem !important;\r\n}\r\n\r\n.phone-input__container .is-invalid {\r\n    border-bottom: 1px solid red !important;\r\n}\r\n\r\n.phone-input__container .is-invalid:focus{\r\n    box-shadow: 0 1px 0 0 red !important;\r\n}\r\n\r\n.phone-input__container {\r\n    width: 100% !important;\r\n    margin-right: 1rem;\r\n}\r\n\r\n.phone-input__container .selected-flag {\r\n    padding: 0 !important;\r\n}\r\n\r\n.phone-input__container .flag-dropdown::before  {\r\n    content: none !important;\r\n}\r\n\r\n.phone-input__container input.phone-input__input {\r\n    width: 38.5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
